import { useEffect } from "react"
import { useSearchParams } from "react-router-dom"

import useFetch from "shared/model/useFetch"
import useAlertModalAtom from "shared/model/useAlertModalAtom"

const useGetFranchiseUsageRightsStatusList = () => {
    const [fetchResult, fetchRequest, isLoading] = useFetch()
    const [searchParams] = useSearchParams()
    const page = searchParams.get("page")
    const search = searchParams.get("search")
    const ticketTypeIdx = searchParams.get("voucherType")
    const sortBy = searchParams.get("sortBy")
    const sortDirection = searchParams.get("sortDirection")

    const [, setAlert] = useAlertModalAtom()

    useEffect(() => {
        let url = `/admin/store_ticket/user/ticket_status?page=${page}`
        if (search) url += `&search=${search}`
        if (ticketTypeIdx) url += `&ticketTypeIdx=${ticketTypeIdx}`
        if (sortBy) url += `&sortBy=${sortBy}`
        if (sortDirection) url += `&sortDirection=${sortDirection}`

        fetchRequest("GET", url)
    }, [page, search, ticketTypeIdx, sortBy, sortDirection])

    useEffect(() => {
        switch (fetchResult?.statusCode) {
            case 400:
                if (fetchResult?.data?.error_code === "page") setAlert("페이지 번호를 확인해 주세요.")
                else if (fetchResult?.data?.error_code === "search") setAlert("검색어를 확인해 주세요.")
                else setAlert("입력한 값의 형식이 잘못되었습니다.")
                break
        }
    }, [fetchResult])

    return [fetchResult, isLoading]
}

export default useGetFranchiseUsageRightsStatusList